<template>
  <span
    :class="[
      'tw-inline-flex tw-items-center tw-rounded-full tw-font-medium tw-whitespace-nowrap',
      sizeClasses,
      colorClasses,
    ]"
  >
    <slot />
  </span>
</template>

<script>
const colorMap = {
  primary:  'tw-bg-nc-primary-tint tw-text-nc-primary',
  success:  'tw-bg-green-100 tw-text-nc-success dark:tw-bg-green-900/30 dark:tw-text-green-400',
  warning:  'tw-bg-yellow-100 tw-text-yellow-700 dark:tw-bg-yellow-900/30 dark:tw-text-yellow-400',
  danger:   'tw-bg-red-100 tw-text-nc-danger dark:tw-bg-red-900/30 dark:tw-text-red-400',
  medium:   'tw-bg-gray-100 tw-text-nc-medium dark:tw-bg-gray-700 dark:tw-text-gray-300',
};

const sizeMap = {
  sm: 'tw-text-[10px] tw-px-2 tw-py-0.5',
  md: 'tw-text-xs tw-px-2.5 tw-py-0.5',
};

export default {
  name: 'NcChip',
  props: {
    color: { type: String, default: 'primary', validator: v => Object.keys(colorMap).includes(v) },
    size: { type: String, default: 'md', validator: v => ['sm', 'md'].includes(v) },
  },
  computed: {
    colorClasses() { return colorMap[this.color]; },
    sizeClasses() { return sizeMap[this.size]; },
  },
};
</script>
